// CSS  

// Lib 
import { mapState } from "vuex";

// Event, Dialog 

// Api 

// Constant  

// Extend 

// Component
import ServerAvailabilityItem from "@/views/component/Package/ServerAvailabilityItem";

export default {

    components: {
        ServerAvailabilityItem,
    },

    data() {
        return {
        }
    },

    computed: {
        ...mapState({
            serverReport: state => state.common.serverReport,
        }),
        cpuItems() {
            return this.serverReport.filter((x) => x.serviceType === 3 && x.showInUserList);
        },
        gpuSingleCardItems() {
            return this.serverReport.filter((x) => x.serviceType === 1 && x.numberCard === 1 && x.showInUserList);
        },
        gpuMultiCardItems() {
            return this.serverReport.filter((x) => x.serviceType === 1 && x.numberCard > 1 && x.showInUserList);
        }
    },

    created() {
    },

    mounted() {
    },

    methods: {
        matomoLog(Category, Action, Name, Value) {
            if(window.matomoEnabled){
                let dataPush = ['trackEvent', Category, Action, Name];
                if (Value) dataPush.push(Value);
                if(window._paq) window._paq.push(dataPush);
            }
        },
    },
}